import {Accordion, AccordionBody, AccordionHeader, AccordionItem, Input} from "reactstrap";
import CompanyForm from "./CompanyForm";
import ShipmentForm from "./ShipmentForm";
import React from "react";


const CreateSmartQuotationAccordion = ({open, toggle, openType}) => {
    const quoteData = {}
    return(
        <Accordion flush open={open} toggle={toggle} className='main_accordion'>
            <>
                <AccordionItem>
                    <AccordionHeader targetId={`customerdetails`}>
                        Company Details
                    </AccordionHeader>
                    <AccordionBody accordionId={`customerdetails`}>
                        <CompanyForm opener={openType}/>
                    </AccordionBody>
                </AccordionItem>
                <AccordionItem>
                    <AccordionHeader targetId={`shipmentdetails`}>
                        Shipment Details
                    </AccordionHeader>
                    <AccordionBody accordionId={`shipmentdetails`}>
                        <ShipmentForm data={quoteData} />
                    </AccordionBody>
                </AccordionItem>
            </>
        </Accordion>
    );
}

export default CreateSmartQuotationAccordion;
